import { Controller } from "@hotwired/stimulus"

const alignmentButtons = [
  { attribute: "alignCenter", label: "Centralizar", icon: "align-center" },
  { attribute: "alignJustify", label: "Justificar", icon: "align-justify" }
]

export default class extends Controller {
  connect() {
    this.addAlignmentButtons = this.addAlignmentButtons.bind(this)
    this.element.addEventListener("trix-initialize", this.addAlignmentButtons)
    this.addAlignmentButtons()
  }

  disconnect() {
    this.element.removeEventListener("trix-initialize", this.addAlignmentButtons)
  }

  insertVariable(event) {
    const editorElement = this.element.querySelector("trix-editor")
    const editor = editorElement?.editor
    if (!editor) return

    editor.insertString(event.currentTarget.dataset.variable)
    editorElement.focus()
  }

  addAlignmentButtons(event) {
    const editors = event?.target?.matches("trix-editor")
      ? [event.target]
      : this.element.querySelectorAll("trix-editor")

    editors.forEach((editor) => {
      const group = editor.toolbarElement?.querySelector("[data-trix-button-group='block-tools']")
      if (!group) return

      alignmentButtons.forEach(({ attribute, label, icon }) => {
        if (group.querySelector(`[data-trix-attribute='${attribute}']`)) return

        const button = document.createElement("button")
        button.type = "button"
        button.className = `trix-button trix-button--icon trix-button--icon-${icon}`
        button.dataset.trixAttribute = attribute
        button.title = label
        button.ariaLabel = `${label} texto`
        button.tabIndex = -1
        button.textContent = label
        group.append(button)
      })
    })
  }
}
